import IconFacebook from '@/assets/svg/purge/icons/icon-facebook.svg'
import IconInstagram from '@/assets/svg/purge/icons/icon-instagram.svg'
import IconPinterest from '@/assets/svg/purge/icons/icon-pinterest.svg'
import IconTikTok from '@/assets/svg/purge/icons/icon-tiktok.svg'
import IconTwitter from '@/assets/svg/purge/icons/icon-twitter.svg'
import IconWeb from '@/assets/svg/purge/icons/icon-website.svg'
import IconYoutube from '@/assets/svg/purge/icons/icon-youtube.svg'
import CreatorPlatform from '@/ts/enums/creator/CreatorPlatform'

const SOCIAL_MEDIA: Record<CreatorPlatform, JSX.Element> = {
  facebook: <IconFacebook />,
  instagram: <IconInstagram />,
  tiktok: <IconTikTok />,
  twitter: <IconTwitter />,
  youtube: <IconYoutube />,
  pinterest: <IconPinterest />,
  www: <IconWeb />,
}

export default SOCIAL_MEDIA
